require('./dist/polyfill')



/*****************
 ** WEBPACK FOOTER
 ** ../~/@formatjs/intl-pluralrules/polyfill.js
 ** module id = 1547
 ** module chunks = 0
 **/